var exhButler1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler1.jpg';
var exhButler2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler2.jpg';
var exhButler3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler3.jpg';
var exhButler4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler4.jpg';
var exhButler5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler5.jpg';
var exhButler6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler6.jpg';
var exhButler7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler7.jpg';
var exhButler8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler8.jpg';
var exhButler9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler9.jpg';
var exhButler10 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler10.jpg';
var exhButler11 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler11.jpg';
var exhButler12 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler12.jpg';
var exhButler13 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler13.jpg';
var exhButler14 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler14.jpg';
var exhButler15 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler15.jpg';
var exhButler16 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler16.jpg';
var exhButler17 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-butler/exhButler17.jpg';

export const allImagesDesktopOrderExhButler = [
    [/*COLUMN 1*/
        [
            {
                name: exhButler1,
                captionln1: "The bus, filled with friends and family from New York City, on its way to Ohio for the opening of the solo show, <b>Breaking The Surface</b>, at The Butler Institute of American Art, courtesy of the amazing, Jack Bashkow.",
                captionln2: "",
                captionln3: "",
                link: "butler1"
            },
        ],
        [
            {
                name: exhButler2,
                captionln1: "The museum catalogue for the solo show, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler2"
            },
        ],
        [
            {
                name: exhButler3,
                captionln1: "The billboard outside the Butler Museum announcing the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler3"
            },
        ],
        [
            {
                name: exhButler4,
                captionln1: "The banner hanging outside the museum announcing the solo exhibition, <b>Breaking The Surface</b>.",
                captionln2: "",
                captionln3: "",
                link: "butler4"
            },
        ],
        [
            {
                name: exhButler5,
                captionln1: "Friends and family outside The Butler Institute of American Art celebrating the exhibition opening in the freezing cold.",
                captionln2: "",
                captionln3: "",
                link: "butler5"
            },
        ],
        [
            {
                name: exhButler6,
                captionln1: "The title wall text in the museum during the solo exhibition, <b>Breaking The Surface</b>.",
                captionln2: "",
                captionln3: "",
                link: "butler6"
            },
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhButler7,
                captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler7"
            },
        ],
        [
            {
                name: exhButler8,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler8"
            },
        ],
        [
            {
                name: exhButler9,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler9"
            },
        ],
        [
            {
                name: exhButler10,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler10"
            },
        ],
        [
            {
                name: exhButler11,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler11"
            },
        ],
        [
            {
                name: exhButler12,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler12"
            },
        ],
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhButler13,
                captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler13"
            },
        ],
        [
            {
                name: exhButler14,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler14"
            },
        ],
        [
            {
                name: exhButler15,
                captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler15"
            },
        ],
        [
            {
                name: exhButler16,
                captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
                captionln2: "",
                captionln3: "",
                link: "butler16"
            },
        ],
        [
            {
                name: exhButler17,
                captionln1: "Shaking hands with Lou Zona, the Director and Chief Curator of The Butler Institute of American Art during the opening of the solo exhibition, <b>Breaking The Surface</b>.",
                captionln2: "",
                captionln3: "",
                link: "butler17"
            }
        ]
    ]          
]

export const allImagesMobileOrderExhButler = [
    [{
        name: exhButler1,
        captionln1: "The bus, filled with friends and family from New York City, on its way to Ohio for the opening of the solo show, <b>Breaking The Surface</b>, at The Butler Institute of American Art, courtesy of the amazing, Jack Bashkow.",
        captionln2: "",
        captionln3: "",
        link: "butler1"
    },
    {
        name: exhButler2,
        captionln1: "The museum catalogue for the solo show, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler2"
    },
    {
        name: exhButler3,
        captionln1: "The billboard outside the Butler Museum announcing the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler3"
    },
    {
        name: exhButler4,
        captionln1: "The banner hanging outside the museum announcing the solo exhibition, <b>Breaking The Surface</b>.",
        captionln2: "",
        captionln3: "",
        link: "butler4"
    },
    {
        name: exhButler5,
        captionln1: "Friends and family outside The Butler Institute of American Art celebrating the exhibition opening in the freezing cold.",
        captionln2: "",
        captionln3: "",
        link: "butler5"
    },
    {
        name: exhButler6,
        captionln1: "The title wall text in the museum during the solo exhibition, <b>Breaking The Surface</b>.",
        captionln2: "",
        captionln3: "",
        link: "butler6"
    },
    {
        name: exhButler7,
        captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler7"
    },
    {
        name: exhButler8,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler8"
    },
    {
        name: exhButler9,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler9"
    },
    {
        name: exhButler10,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler10"
    },
    {
        name: exhButler11,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler11"
    },
    {
        name: exhButler12,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler12"
    },
    {
        name: exhButler13,
        captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler13"
    },
    {
        name: exhButler14,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler14"
    },
    {
        name: exhButler15,
        captionln1: "The gallery interior during the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler15"
    },
    {
        name: exhButler16,
        captionln1: "The opening of the solo exhibition, <b>Breaking The Surface</b>, at The Butler Institute of American Art.",
        captionln2: "",
        captionln3: "",
        link: "butler16"
    },
    {
        name: exhButler17,
        captionln1: "Shaking hands with Lou Zona, the Director and Chief Curator of The Butler Institute of American Art during the opening of the solo exhibition, <b>Breaking The Surface</b>.",
        captionln2: "",
        captionln3: "",
        link: "butler17"
    }]      
]
